import { apiClient, getPage } from '@/api/client'
import type { components } from '@/api/schema'
import {
  commodityPricesSchema,
  type CommodityKind,
  type CommodityPrice,
} from '@/schemas/commodities'

type WireCommodity = components['schemas']['CommodityPrice']

/** Which mark each slug draws. A slug this build has no mark for drops its row. */
const KIND_BY_KEY: Readonly<Record<string, CommodityKind>> = {
  'fine-gold': 'gold',
  'tejabi-gold': 'gold',
  silver: 'silver',
  petrol: 'fuel',
  diesel: 'fuel',
  kerosene: 'fuel',
  lpg: 'gas',
}

/** "-3200.00" moves by whole rupees; "2.50" by paisa. */
const decimalsOf = (change: string): 0 | 2 => (/^-?\d+(\.0+)?$/.test(change) ? 0 : 2)

const toCommodityPrice = (row: WireCommodity) => ({
  key: row.key,
  name: row.name,
  unit: row.unit === null ? null : `per ${row.unit}`,
  kind: KIND_BY_KEY[row.key],
  price: row.price,
  change: row.change,
  deltaDecimals: row.change === null ? 0 : decimalsOf(row.change),
})

export const commodityPricesService = {
  /**
   * `GET /api/v5/commodities/` (public): the desk's daily quotes, already in the order they are
   * drawn (fine gold, silver, petrol, LPG first). A row with no price, or a slug with no mark, is
   * dropped.
   */
  rail: async (): Promise<CommodityPrice[]> => {
    const page = await getPage<WireCommodity>(() => apiClient.GET('/api/v5/commodities/'))
    return commodityPricesSchema.parse(page.rows.map(toCommodityPrice))
  },
}
